import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import List from "./List";
import Header from "./Header";
import EditProductCategoryDetails from "./edit";
import ProductCategoryDetailsRoute from "./Details/index";
import NewProductCategory from "./New/index";
import NewProductType from "./New/index";
import EditProductTypeDetails from "./edit";
import ProductTypeDetailsRoute from "./Details/index";

function ProductTypes() {
  const location = useLocation();

  return (
    <Routes>
      <Route
        element={
          <>
            {/* {location.pathname.includes("/items/edit-item") ? (
              <></>
            ) : (
              <Header />
            )} */}
            <Outlet />
          </>
        }
      >
        <Route
          path="/list"
          element={
            <>
              <Header />

              <List />
            </>
          }
        />

        <Route
          path="new"
          element={
            <>
              <NewProductType />
            </>
          }
        />
        <Route
          path="edit/:id"
          element={
            <>
              {/* <EditModule
                module={"items"}
                modulePath="/items"
                primary_key="item_id"
              /> */}
              <EditProductTypeDetails />
            </>
          }
        />

        <Route
          path="details/:id"
          element={
            <>
              <ProductTypeDetailsRoute className={""} />
            </>
          }
        />

        {/* <Route path="/summary" element={<Summary />} /> */}

        <Route index element={<Navigate to="/product-types/list" />} />
      </Route>
    </Routes>
  );
}

export default ProductTypes;
